<section class="blog blog-grid pt-70 pb-90">
    <div class="container pairblank">
      <div class="page__section">
            <nav class="breadcrumb breadcrumb_type5" aria-label="Breadcrumb">
                <ol class="breadcrumb__list r-list">
                    <li class="breadcrumb__group">
                        <a [routerLink]="['/dividend']" title="Temettü"class="breadcrumb__point r-link">Temettü</a>
                        <span class="breadcrumb__divider" aria-hidden="true">›</span>
                    </li>
                    <li class="breadcrumb__group">
                        <span class="breadcrumb__point" aria-current="page">{{dividendLast?.name}}</span>
                    </li>
                </ol>
            </nav>
        </div>
        <div class="row" style="padding: 15px;">
            <div class="col-sm-12 col-md-12 col-lg-8 mb-30-xs mb-30-sm" >
                <div class="row">
                    <nav class="accordion arrows">
                        <header class="box public-offering-header">
                            <h1>{{dividendLast?.title}} <span class="visible-title">Hisse Temettü</span></h1>
                        </header>
                        <div class="row" *ngFor="let dividend of dividends ; trackBy:trackByFnDividend">
                            <div class="col" style="font-weight:bold;">Ödeme Tarihi</div>
                            <div class="col">{{dividend?.cashDvdndDt?(dividend?.cashDvdndDt | date:'d MMMM y'):'Belirtilmedi'}}</div>
                            <div class="w-100"></div>
                            <div class="col" style="font-weight:bold;">Duyuru Tarihi</div>
                            <div class="col">{{dividend?.regstrDt | date:'d MMMM y'}}</div>
                            <div class="w-100"></div>
                            <div class="col" style="font-weight:bold;">Toplam Temettü</div>
                            <div class="col">{{dividend?.cashDvdnd | currency:'TRY'}}</div>
                            <div class="w-100"></div>
                            <div class="col" style="font-weight:bold;">VD %</div>
                            <div class="col">{{dividend?.capital}}</div>
                            <div class="w-100"></div>
                            <div class="col" style="font-weight:bold; margin-bottom: 10px;">HBVD</div>
                            <div class="col">{{dividend?.cashDvdndB}}</div>
                            <div class="w-100"></div>
                            <div class="col" style="font-weight:bold; margin-bottom: 10px;">HBVH</div>
                            <div class="col">{{dividend?.cashDvdndH}}</div>
                            <div class="w-100"></div>
                            <div class="col" style="font-weight:bold; margin-bottom: 10px;">SPK Onayı</div>
                            <div class="col" [ngStyle]="{'color': dividend?.spk? 'green' : 'red'}">{{dividend?.spk?'Onaylandı':'Onaylanmadı'}}</div>
                            <div class="w-100"></div>
                            <div class="col" style="font-weight:bold; margin-bottom: 10px;">Durumu</div>
                            <div class="col" [ngStyle]="{'color': dividend?.apply? 'green' : 'red'}">{{dividend?.apply?'Tamamlandı':'Tamamlanmadı'}}</div>
                            <hr>
                        </div>
                        <div class="row pt-3" *ngFor="let link of linkList ; trackBy: trackByFnLink">
                            <div class="col" style="font-weight:bold;">
                                <a class="text-link" href="{{link.url}}" >{{link.title}}</a></div>
                            <div class="w-100"></div>
                        </div>
                        <br>
                        <app-financial-statement [code]="dividendLast?.code"></app-financial-statement>
                        <app-stock-chart [code]="dividendLast?.code"></app-stock-chart>
                        <app-company [code]="dividendLast?.code"></app-company>
                    </nav>
                </div>
                <div class="widget market-pricing market-list card mb-3 mt-70 " style="position: relative; padding:10px; margin-top: 50px;">
                    <div class="row">
                        <div class="col-4"style="width:auto;height:auto;">
                            <picture>
                                <source media="(max-width: 150px)" srcset="{{domainURL}}temettu-hisseleri.webp" />
                                <source media="(min-width: 150px)" srcset="{{domainURL}}temettu-hisseleri.webp" />
                                <img loading="lazy" width="150px" height="110px" src="{{domainURL}}temettu-hisseleri.webp" alt="Temettü Hisseleri" title="Temettü Hisseleri">
                            </picture></div>
                        <div class="col"><strong>{{dividendLast?.name}} Temettü Hisse Bilgisi</strong> , ve daha fazla şirketin Temettü tarihleri için<a [routerLink]="['/dividend']" title="Temettü"><strong> Temettü</strong></a> sayfasını ziyaret edebilirsiniz.</div>
                        <div class="w-100"></div>
                        <br>
                        <p>Şirketlerin, hisselerin ve güncel borsa analizlerine <strong><a [routerLink]="['/analysis']" title="Analiz">Analiz </a></strong>sayfamızdan ulaşabilirsiniz.</p>
                    </div>
                    <div class="row ">
                        <app-calculate-in></app-calculate-in>
                    </div>
                </div>
                <div class="widget market-pricing market-list card mb-3" style="position: relative; padding:10px; margin-top:50px;">
                    <app-comment [commentCount]="commentCount" [title]="title" [rootId]="rootId"></app-comment>
                </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-4">
                <app-draft-dividend [toYear]="toYear"></app-draft-dividend>
                <app-draft-month [toYear]="toYear"></app-draft-month>
                <app-summary-info></app-summary-info>
                <app-summary-analysis [imageStatus]="true" [count]="5"></app-summary-analysis>
            </div>
        </div>
        <p class="visible-title"><strong>{{dividendLast?.code}} Hisse </strong><strong>{{dividendLast?.name}} Hisse </strong><strong>Temettü Hisseleri</strong><strong>Temettü Tarihleri</strong></p>
    </div>
</section>
